import styled from '@emotion/styled'
import { wrap as withStyle, stylesIf } from 'utils/styles'
import { getGradientType } from '../gradients'

export default withStyle(
  () => `
    width:100%;
    display:flex;
    align-items: center;
    justify-content: space-between;
  `
)

export const StyledLineContainer = styled.div(({ maxBarWidth }) => {
  return `
  flex-grow: 1;
  margin-left: 8px;
  position: relative;
  ${stylesIf(maxBarWidth, `max-width: ${maxBarWidth}px`)}
`
})

export const StyledBgLine = styled.div(
  ({ theme }) => `
    width: 100%;
    height:0;
    border: 2px solid ${theme.vehicleBackroundColor};
    border-radius: 2px;
  `
)

export const StyledLine = styled.div(({ proportion }) => {
  const widthPercent = Math.min(100 * proportion, 100)
  const color = getGradientType(proportion, true)
  return `
    position:absolute;
    bottom: 0;
    width: ${widthPercent}%;
    height: 4px;
    background: ${color};
    border-radius: 2px;
  `
})
